import ROUTES from '@lib/constants/routes';
import { usePathname } from 'next/navigation';
export const useMatchedRoute = () => {
  const pathname = usePathname();
  const visualMatch = pathname.includes(ROUTES.flats.visual.root);
  const houseMatch = pathname.includes(ROUTES.flats.visual.house);
  const floorMatch = pathname.includes(ROUTES.flats.visual.floor);
  const bulkMatch = pathname.includes(ROUTES.flats.visual.bulk);
  if (floorMatch) {
    return "floor";
  }
  if (houseMatch) {
    return "house";
  }
  if (visualMatch) {
    return "visual";
  }
  if (bulkMatch) {
    return "bulk";
  }
  return null;
};